<template>
  <section class="min-h-screen bg-black px-4 py-16 sm:py-24">
    <div class="mx-auto w-full max-w-4xl">
      <h2 class="mb-12 text-center text-3xl font-bold text-white md:text-4xl">
        Dúvidas Frequentes - <span class="text-orange-500">FAQ</span>
      </h2>

      <div class="space-y-4">
        <div 
          v-for="(faq, index) in faqs" 
          :key="index" 
          class="rounded-xl bg-zinc-900 transition-all duration-300"
        >
          <button
            class="flex w-full items-center justify-between p-4 text-left sm:p-5"
            @click="toggleFaq(index)"
          >
            <span class="text-base font-medium text-white sm:text-lg">{{ faq.question }}</span>
            
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 shrink-0 text-gray-400 transition-transform duration-300"
              :class="{ 'rotate-180': openIndex === index }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <div v-if="openIndex === index" class="px-4 pb-5 sm:px-5">
            <p class="text-sm text-gray-300 sm:text-base">
              {{ faq.answer }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// MODIFICADO: Imports do Font Awesome foram removidos, não são mais necessários
export default {
  name: "FaqSection",
  // MODIFICADO: Registro do componente Font Awesome removido
  components: {},
  data() {
    return {
      faqs: [
        { question: "Existe um tempo mínimo para a assinatura?", answer: "Se você ainda estiver em dúvidas quanto ao nosso serviço, recomendamos a assinatura mensal. Dessa maneira, você é livre para cancelar cobranças futuras quando desejar, sem nenhuma multa. Para assinaturas trimestrais ou semestrais, é necessário permanecer o tempo contratado." },
        { question: "A OverX cobra alguma taxa por pedidos?", answer: "Não! Não cobramos nenhuma taxa adicional. Você paga apenas uma mensalidade fixa pelo uso da nossa plataforma." },
        { question: "Como funcionará o suporte da equipe após a assinatura?", answer: "Nossa equipe está pronta para prover o total apoio em todo processo de implantação e no pós-implantação, tanto via WhatsApp, e-mail e por videochamadas. Estamos disponíveis das 09h até 23h. Além disso, o nosso agente virtual está disponível 24/7 para um auxílio rápido." },
        { question: "Consigo colocar no ar o meu cardápio digital no mesmo dia?", answer: "Nosso sistema é intuitivo e fácil de usar. Assim que se cadastrar, você pode iniciar as configurações e testar a plataforma. Se já tiver um cardápio cadastrado no iFood, isso adiantará ainda mais o processo. O tempo de conclusão depende do seu ritmo." },
        { question: "Depois que eu adquirir a assinatura, o que acontece?", answer: "Assim que a assinatura for confirmada, você receberá automaticamente um e-mail com um link de um formulário solicitando informações da sua empresa. A partir desse momento, em até 2 dias úteis, você estará com acesso à plataforma com seu login e senha de acesso à plataforma." },
        { question: "Posso gerenciar meu delivery apenas pelo celular?", answer: "Pode! O fluxo de gestão diária pode ser feito via smartphone através do nosso app OverX Store. Porém, o fluxo de configuração inicial da empresa no sistema, recomendamos que seja feito pelo navegador no computador." },
        { question: "Como faço para assinar a OverX?", answer: "Em nosso site, escolha seu plano e você será redirecionado para o cadastro de acesso à plataforma." },
        { question: "Meu cliente vai precisar baixar algum aplicativo ou fazer login para realizar um pedido?", answer: "Não, o cliente não precisa baixar nenhum app para fazer um pedido. Com o link do seu cardápio digital, ele poderá efetuar as compras com facilidade. Nós coletamos apenas o nome e o telefone, informações essenciais para o gerenciamento." },
      ],
      openIndex: null,
    };
  },
  methods: {
    toggleFaq(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
/* MODIFICADO: Todo o CSS customizado foi removido. O estilo agora é 100% controlado pelo Tailwind CSS no template. */
</style>